import React, { Component } from "react";
import { Typography /* Button */ } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";

export default class EmailVerification extends Component {
  render() {
    return (
      <Paper align="center" square elevation={0}>
        <Typography variant="h4" align="center">
          Email Verification failed
        </Typography>
        <Typography>Please sign in and try again.</Typography>
        {/* <Button color="primary" variant="outlined">Sign in</Button> */}
      </Paper>
    );
  }
}
